 
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "./AdminComp/Sidebar";
import BookingChart from "./AdminComp/BookingChart";
import BreadCrumb from "./AdminComp/BreadCrumb";
import { useNavigate } from "react-router-dom";


function AdminDashboard() {

  const navigate = useNavigate(); // Initialize the navigate function

  useEffect(() => {
    // Retrieve stored adminId and email from localStorage
    const adminId = localStorage.getItem("adminId");
    const email = localStorage.getItem("email");

    // Log the values
    console.log("Stored adminId:", adminId);
    console.log("Stored email:", email);

    // If adminId is not available, redirect to the login page
    if (!adminId || !email) {
      navigate("/admin-login"); // Navigate to admin login page if adminId or email is not found
    }
  }, [navigate]); 


  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>

          <div className=" ">
            <BreadCrumb/>
            <div className="container-fluid">
              

              <div className="crdmain mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="chart-title text-start">
                  Welcome to Dashboard 
                </h2> 
              </div>

                <div className="row g-2 mt-0 mb-0">
                  <div className="col-md-3  p-2">
                    <div className="ag1 p-2">
                      <div className="ag4">
                        <span className="agsvg1 cl1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#FFFFFF"
                          >
                            <path d="M280-80v-100l120-84v-144L80-280v-120l320-224v-176q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800v176l320 224v120L560-408v144l120 84v100l-200-60-200 60Z" />
                          </svg>
                        </span>
                      </div>
                      <div className="ag2 font4">29</div>
                      <div className="ag3 font4">Total Bookings</div>
                    </div>
                  </div>

                  <div className="col-md-3   p-2">
                    <div className="ag1 p-2">
                      <div className="ag4">
                        <span className="agsvg1 cl2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#FFFFFF"
                          >
                            <path d="M40-200v-600h80v400h320v-320h320q66 0 113 47t47 113v360h-80v-120H120v120H40Zm240-240q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm240 40h320v-160q0-33-23.5-56.5T760-640H520v240ZM280-520q17 0 28.5-11.5T320-560q0-17-11.5-28.5T280-600q-17 0-28.5 11.5T240-560q0 17 11.5 28.5T280-520Zm0-40Zm240-80v240-240Z" />
                          </svg>
                        </span>
                      </div>
                      <div className="ag2 font4">29</div>
                      <div className="ag3 font4">Total Enquiry</div>
                    </div>
                  </div>

                  <div className="col-md-3   p-2">
                    <div className="ag1 p-2">
                      <div className="ag4">
                        <span className="agsvg1 cl3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#FFFFFF"
                          >
                            <path d="M178-720h234-234Zm62 280h-80 480-400ZM160-80q-17 0-28.5-11.5T120-120v-82q-20-21-30-46.5T80-300v-380q0-89 82.5-124.5T451-840q-13 18-22.5 38T412-761q-102 2-157.5 12T178-720h225q-3 20-3 40t3 40H160v120h291q17 24 38 44.5t47 35.5H160v120q0 33 23.5 56.5T240-240h320q33 0 56.5-23.5T640-320v-83q20 3 40 3t40-3v103q0 26-10 51.5T680-202v82q0 17-11.5 28.5T640-80h-40q-17 0-28.5-11.5T560-120v-40H240v40q0 17-11.5 28.5T200-80h-40Zm520-400q-83 0-141.5-58.5T480-680q0-82 58-141t142-59q83 0 141.5 58.5T880-680q0 83-58.5 141.5T680-480Zm-20-160h40v-160h-40v160Zm20 80q8 0 14-6t6-14q0-8-6-14t-14-6q-8 0-14 6t-6 14q0 8 6 14t14 6ZM260-280q25 0 42.5-17.5T320-340q0-25-17.5-42.5T260-400q-25 0-42.5 17.5T200-340q0 25 17.5 42.5T260-280Zm280 0q25 0 42.5-17.5T600-340q0-25-17.5-42.5T540-400q-25 0-42.5 17.5T480-340q0 25 17.5 42.5T540-280Z" />
                          </svg>
                        </span>
                      </div>
                      <div className="ag2 font4">29</div>
                      <div className="ag3 font4">Total Staff</div>
                    </div>
                  </div>

                  <div className="col-md-3   p-2">
                    <div className="ag1 p-2">
                      <div className="ag4">
                        <span className="agsvg1 cl4">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#FFFFFF"
                          >
                            <path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" />
                          </svg>
                        </span>
                      </div>
                      <div className="ag2 font4">29</div>
                      <div className="ag3 font4">Total Agents</div>
                    </div>
                  </div>

                  <div className="col-md-3   p-2">
                    <div className="ag1 p-2">
                      <div className="ag4">
                        <span className="agsvg1 cl4">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#FFFFFF"
                          >
                            <path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" />
                          </svg>
                        </span>
                      </div>
                      <div className="ag2 font4">29</div>
                      <div className="ag3 font4">Total Revenue in Jan</div>
                    </div>
                  </div>
 

                  <div className="col-md-3   p-2">
                    <div className="ag1 p-2">
                      <div className="ag4">
                        <span className="agsvg1 cl4">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24px"
                            viewBox="0 -960 960 960"
                            width="24px"
                            fill="#FFFFFF"
                          >
                            <path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" />
                          </svg>
                        </span>
                      </div>
                      <div className="ag2 font4">29</div>
                      <div className="ag3 font4">Total Packages</div>
                    </div>
                  </div>

                </div>
              </div>

              <div className="row g-3">
                <div className="col-md-8">
                  <div className="">
                    <BookingChart />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className=""></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminDashboard;
